<template>
    <v-card>
        <v-card-title>
        <span class="headline">Cargo Conveyance Detail</span>
      </v-card-title>
      <v-card-text>
        <message :messages="messages"></message>
        <form>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs6 v-if="newConvy">
                <v-text-field :label="labels.convy" v-model="convyForm.convy" :error-messages="errors.collect('convy')" data-vv-name="convy" :data-vv-as="labels.convy" v-validate="'required|param|max:8'"></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.convy}}</v-subheader>
                <div class="title">{{convyForm.convy}}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="convyForm.convyDesc" :label="labels.convyDesc" :error-messages="errors.collect('convyDesc')" v-validate="'required|entry|max:100'" data-vv-name="convyDesc" :data-vv-as="labels.convyDesc"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="doCancel">Cancel</v-btn>
        <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  props: {
    'convyForm': Object,
    'newConvy': Boolean
  },
  data() {
    return {
      labels: {
        convy: 'Conveyance Code*',
        convyDesc: 'Conveyance Description*'
      },
      submitting: undefined
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.convyForm.convy = undefined
      this.convyForm.convyDesc = undefined
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newConvy) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.cargo.menu.createConvy
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.convyForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.cargo.menu.updateConvy
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.convyForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.doInit()
      this.$emit('close')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
